module.exports = __webpack_public_path__ + "assets/38b1d18836e38ee7b4deaeba0c35f7b8.js";